import { SolitaireGame } from 'game/SolitaireGame';
import { MagicItem, MagicPlace } from './magicGroup';
import { Card } from 'components/Card';
import { GameBoardPlace } from 'game/GameBoardPlace';
import { uniqueBy } from 'game/utils/array';
import { getRandomUniqueElements } from 'game/utils/random';

// The priority of the area for card selection:
// 1. hidden cards
// 2. inactive cards

export function findSpiderMagic(game: SolitaireGame) {
    const items = getCardFromPlace([
        ...getCardsForFirstCase(game),
        ...getCardsForSecondCase(game),
        ...getCardsForThirdCase(game),
    ], game);

    const uniqueItems = uniqueBy(items, (item) => item?.moveCard?.code);
    const uniqueItems2 = uniqueBy(uniqueItems, (item) => item?.targetCard?.code);

    return getRandomUniqueElements(uniqueItems2, 2);
}

function getCardFromPlace(inactiveCards: Card[], game: SolitaireGame) {
    if (inactiveCards.length === 0) return [];

    const sequences = game.columns.map((column) => column.getLastMoveGroup());
    // sequences.sort((a, b) => b.length - a.length);
    //   11:01 AM Mar 17
    // We are not looking for the largest sequence. Just take any card.

    const validCardsToMove = [] as {
        priority: number;
        moveCard: Card;
        to: GameBoardPlace;
        place: MagicPlace;
        targetCard: Card | null;
    }[];
    sequences.forEach((s) => {
        if (s.length === 0) return;
        const lastCard = s[s.length - 1];
        const firstCard = s[0];

        for (let index = 0; index < inactiveCards.length; index++) {
            const inactiveCard = inactiveCards[index];
            if (lastCard.cardColor !== inactiveCard.cardColor) continue;

            if (lastCard.value - 1 === inactiveCard.value) {
                validCardsToMove.push({
                    priority: s.length,
                    moveCard: inactiveCard,
                    to: game.getCardBoardPlace(lastCard),
                    place: MagicPlace.AFTER,
                    targetCard: lastCard,
                });
            }
            if (firstCard.value + 1 === inactiveCard.value) {
                validCardsToMove.push({
                    priority: s.length,
                    moveCard: inactiveCard,
                    to: game.getCardBoardPlace(firstCard),
                    place: MagicPlace.BEFORE,
                    targetCard: firstCard,
                });
            }
        }
    });

    return validCardsToMove.filter(item => item?.moveCard && item?.targetCard).map(item => new MagicItem(item.moveCard, item.to, item.place, item.targetCard));
}
function getCardsForFirstCase(game: SolitaireGame) {
    // ==== CHECK 1: Tableau (hidden cards). ====
    //Looking for the largest sequence

    const hiddenCards = [] as Card[];
    game.columns.forEach((column) =>
        column.cards.forEach((c) => {
            if (!c.visible) hiddenCards.push(c);
        })
    );
    return hiddenCards;
}

function getCardsForSecondCase(game: SolitaireGame) {
    // ==== CHECK 2: Tableau (inactive cards). ====

    const hiddenCards = [] as Card[];
    game.columns.forEach((column) =>
        column.cards.forEach((c, i) => {
            if (!c.visible) return;
            if (c.active) return;

            const prevCard = i > 0 ? column.cards[i - 1] : null;
            const nextCard = column.cards[i + 1];
            if (prevCard) {
                if (prevCard.cardColor === c.cardColor && prevCard.canDropInColumn(c)) return;
            }
            if (nextCard && nextCard.cardColor === c.cardColor && c.canDropInColumn(nextCard)) return;

            hiddenCards.push(c);
        })
    );

    return hiddenCards;
}
function getCardsForThirdCase(game: SolitaireGame) {
    // ==== CHECK 2: Tableau (inactive cards). ====
    // any sequence of cards that can be moved to another column

    const validOrderGroups = [[]] as Card[][];
    let currentGroupIndex = 0;

    game.columns.forEach((column) => {
        let prevCard = null as Card | null;

        for (let index = column.length - 1; index >= 0; index--) {
            const card = column.cards[index];
            if (card.active) continue;

            if (column.validOrder(card, prevCard)) {
                validOrderGroups[currentGroupIndex].push(card);
            } else {
                currentGroupIndex++;
                validOrderGroups[currentGroupIndex] = [card] as Card[];
            }
            prevCard = card;
        }
    });
    validOrderGroups.sort((a, b) => a.length - b.length);
    
    const magicItems = validOrderGroups.flatMap((group) => group);

    return magicItems;
}
